import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { ItemsProgress } from '../Components/Items-Progress/ItemsProgress';
import { useProfile } from '../Contexts/ProfileContext';
import './CheckoutLayout.scss';

export function CheckoutLayout() {
  const location = useLocation();
  const { profileData } = useProfile();
  const cartCount = profileData?.data?.cartCount ?? 0;
  const isCartPage = location.pathname.includes('/cart');
  const isSuccessPage = location.pathname.includes('/order-success');
  const showProgress = !isSuccessPage && !(isCartPage && cartCount === 0);

  const getActiveStep = () => {
    if (location.pathname.includes('/order-summary')) {
      return 3;
    } else if (location.pathname.includes('/add-address')) {
      return 2;
    } else if (location.pathname.includes('/cart')) {
      return 1;
    }
    return 1;
  };

  return (
    <div className="checkout-layout">
      {showProgress && <ItemsProgress active={getActiveStep()} />}
      <Outlet />
    </div>
  );
}






